import AvatarIcon from '../assets/icons/avatar.svg'
import Circle from '../assets/icons/Ellipse.svg'
import Pen from '../assets/icons/edit.svg'

export default function UserComponent({ profile, loading }) {
    return (
        <div className="flex bg-bg rounded-[16px] items-center justify-center">
            <div className="flex flex-col px-8 sm:px-[80px] py-[38px] items-center justify-center">
                <div className='relative'>
                    <img src={AvatarIcon} alt='ico' className="w-[75px] h-[75px]" />
                    <img src={Circle} alt='' className='absolute bottom-0 right-0 w-6 h-6' />
                    <img src={Pen} alt='edit' className='absolute bottom-[5px] right-[5px] w-3.5 h-3.5' />
                </div>
                <p className="text-white text-[18px] font-semibold py-2 text-center">
                    {loading ? 'Loading...' : (profile?.display_name || 'Not connected')}
                </p>
                <p className="text-white text-[14px]">
                    {profile?.username || '—'}
                </p>
            </div>
        </div>
    )
}
